<template>
  <v-card>
    <v-card-title>
      Login User
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
        v-bind:headers="headers"
        v-bind:items="items"
        v-bind:search="search"
      >
      <template slot="items" slot-scope="props">
        <td class="layout px-0">
          <v-btn icon :to="{name: 'loginUserEdit', params: { id: props.item.loginId }}"><v-icon color="grey">edit</v-icon></v-btn>
        </td>
        <td>
          <v-edit-dialog
            lazy
          > {{ props.item.loginEmailAddress }}
            <v-text-field
              slot="input"
              label="Edit"
              v-model="props.item.loginEmailAddress"
              single-line
              counter
              :rules="[max25chars]"
            ></v-text-field>
          </v-edit-dialog>
        </td>
        <td class="text-xs-right">{{ props.item.firstName }}</td>
        <td class="text-xs-right">{{ props.item.lastName }}</td>
        <td class="text-xs-right">{{ props.item.careGroupId }}</td>
        <td class="text-xs-right">{{ props.item.userAccountType.description }}</td>
        <td class="text-xs-right">{{ props.item.phone.phone }}</td>
        <td class="text-xs-right">{{ props.item.pager.pagerNumber }}</td>
        <td class="text-xs-right">{{ props.item.lastLoginAt }}</td>
        <td class="text-xs-right">
          <v-edit-dialog
            @open="tmp = props.item.userStatus"
            @save="props.item.userStatus = tmp || props.item.userStatus"
            large
            lazy
          >
            <div>{{ props.item.userStatus }}</div>
            <div slot="input" class="mt-3 title">Update User Status</div>
            <v-text-field
              slot="input"
              label="Edit"
              v-model="tmp"
              single-line
              counter
              autofocus
              :rules="[max25chars]"
            ></v-text-field>
          </v-edit-dialog>
        </td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <div class="red white--text subheading">{{ error }}</div>
  </v-card>
</template>

<script>
  import mixins from '@/mixins.js'
  import LoginUserService from '@/services/LoginUserService'

  export default {
    data () {
      return {
        max25chars: (v) => v.length <= 45 || 'Input too long!',
        tmp: '',
        search: '',
        selected: [],
        pagination: {},
        headers: [
          { text: 'Edit',
            align: 'left',
            sortable: false,
            value: null},
          {
            text: 'Login Email Address',
            align: 'left',
            sortable: false,
            value: 'loginEmailAddress'
          },
          { text: 'First Name', value: 'firstName' },
          { text: 'Last Name', value: 'lastName' },
          { text: 'Care Group', value: 'careGroupId' },
          { text: 'User Account Type', value: 'userAccountType.description' },
          { text: 'Phone', value: 'phone.phone' },
          { text: 'Pager', value: 'pager.pagerNumber' },
          { text: 'Last Login At', value: 'lastLoginAt'},
          { text: 'User Status', Value: 'userStatus'}
        ],
        error: '',
        items: []
      }
    },
    mixins: [mixins],
    async mounted () {
      try {
        this.error = ''
        this.items = (await LoginUserService.index()).data
      } catch (error) {
        this.error = this.handleError(error)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/LoginUser.vue